import { useContext, createContext } from 'react';

const StravaExperimentContext = createContext({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getExperiment: (name) => {}
});

if (process.env.NODE_ENV === 'development') {
  StravaExperimentContext.displayName = 'StravaExperimentContext';
}

export function useStravaExperiment() {
  const context = useContext(StravaExperimentContext);

  if (!context) {
    throw new Error(
      'useStravaExperiment must be used within the StravaExperimentContext.Provider'
    );
  }

  return context;
}

export default StravaExperimentContext;
